<template>
  <div class="home">
    <!-- Hero section -->
    <section class="home__section hero">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" sm="10" md="10" lg="9">
            <h1 class="hero__title">
              Conectamos talentos y trabajos desde el propósito
            </h1>
            <p class="hero__text">
              Somos la plataforma líder en conectar personas y organizaciones, para
              emprendimientos, empresas de impacto y organizaciones sin fines de lucro.
            </p>
            <p class="hero__stats">+ 200.000 Talentos | + 1.500 Organizaciones | + 5.000 Ofertas Publicadas</p>
            <v-btn class="hero__btn" to="/register/candidate">
              RECIBE TRABAJOS EN TU MAIL
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Search section -->
    <section class="home__section search-section">
      <!-- #search Anchor -->
      <div id="search" class="d-hidden"></div>

      <!-- Search input -->
      <v-container class="py-0 pt-2">
        <v-text-field
          class="search-section__input"
          label="Buscar"
          v-model="searchText"
          prepend-inner-icon="mdi-magnify"
          clearable
          solo
          @input="searchKeyInput()"
          @keyup.enter.native="searchOffer()"
          @click:clear="onSearchClear"
        />
      </v-container>
    </section>

    <!-- Featured offers section -->
    <section
      v-if="featuredOffers && featuredOffers.length > 0"
      class="home__section featured-offers pt-0 pt-md-16"
    >
      <h2 class="home__title">Ofertas destacadas</h2>
      <HomeOfferList
        show="featured"
        ref="offersList"
      />
    </section>

    <!-- Normal offers section -->
    <section
      class="home__section normal-offers"
      :class="{'pt-md-16': !(featuredOffers && featuredOffers.length > 0)}"
    >

      <h2 class="home__title">
        {{ featuredOffers && featuredOffers.length > 0 ? "Otras ofertas" : "Ofertas de trabajo" }}
      </h2>

      <HomeOfferList
        show="normal"
        ref="offersList"
      />
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HomeOfferList from "@/components/HomeOfferList";
import { meta } from "@/libs/mixins";

export default {
    name: "Home",
    
    components: { HomeOfferList },

    mixins: [meta],

    metaInfo() {
        return {
            ...this.getMetaInfo(),
            titleTemplate: null,
        };
    }, 
    
    data() {
        return {
            timerId: null,
            searchText: "",
            searchedText: "",
            loading: true,
        };
    },
    
    computed: {
        ...mapGetters("offers", ["featuredOffers", "normalOffers"]),

        thereAreOffers() {
            return this.normalOffers.length > 0 || this.featuredOffers.length > 0;
        },
    },

    methods: {
        ...mapActions("offers", ["getOffers"]),

        searchKeyInput() {
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                this.searchOffer();
            }, process.env.VUE_APP_SEARCH_TIMEOUT);
        },
        async searchOffer() {
            if (this.searchedText != this.searchText) {
                await this.getOffers(this.searchText.replace(/ /g, ","));
                this.searchedText = this.searchText;
            }
            this.loading = false;
        },
        async onSearchClear() {
            this.loading = true;
            await this.getOffers();
            this.loading = false;
        },
    }
};
</script>
